/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAnthropicPlatform extends models.BaseCostProcessingMemory {
    constructor() {
        super();
        this.setDiscriminator("CostProcessingMemoryForAnthropicPlatform");
    }

    getFixupPrototypeFunction() { return CostProcessingMemoryForAnthropicPlatform.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAnthropicPlatform>): CostProcessingMemoryForAnthropicPlatform {
        let obj = Object.assign(new CostProcessingMemoryForAnthropicPlatform(), model);
        CostProcessingMemoryForAnthropicPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAnthropicPlatform>): CostProcessingMemoryForAnthropicPlatform {
        if (!model) return null;
        return CostProcessingMemoryForAnthropicPlatform.newInstance(<CostProcessingMemoryForAnthropicPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAnthropicPlatform) {
        if (!obj) return;

        models.CostProcessingMemoryForAnthropicPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAnthropicPlatform): boolean {
        if (models.BaseCostProcessingMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForAnthropicPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.periods) {
            for (let val of this.periods) {
                models.CostProcessingPeriodMemoryForAnthropicPlatform.fixupPrototype(val);
            }
        }
    }

    /**
     * Attributed billing periods
     */
    periods: Array<models.CostProcessingPeriodMemoryForAnthropicPlatform>;

}
